<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav main_aside"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    <megastore-admin-sidebar></megastore-admin-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="toggle" (click)="toggleSidenav()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="top_header_ryt">
        <!-- Inventory Alert Icon -->
        <button mat-icon-button
          [matMenuTriggerFor]="inventoryMenu"
          matBadgeColor="warn"
          matBadgeOverlap="false"
          class="inventory-alert-btn">
          <i class="fa fa-box"></i>
        </button>

        <mat-menu
          #inventoryMenu="matMenu"
          xPosition="before"
          yPosition="below"
          class="noti_dropBox">
          <div class="d_flx">
            <h2>{{ 'LowStockAlerts' | translate }}</h2>
            <button
              class="see_link"
              routerLink="/low-stocks"
              type="button">
              {{ 'SeeAll' | translate }}
            </button>
          </div>

          <ul class="not_list" *ngIf="lowStockItems.length > 0; else noAlerts">
            <li class="ntf-list" *ngFor="let item of lowStockItems">
              <div class="ntf_dt">
                <h3>{{item.productName}}</h3>
                <p class="vendor-name">{{item.vendorName}}</p>
                <p class="stock-info">
                  <span class="quantity" [class.critical]="item.availableQuantity <= 0">
                    {{ 'Quantity' | translate }}: {{item.availableQuantity}}
                  </span>
                  <span class="threshold">{{ 'Threshold' | translate }}: {{item.threshold}}</span>
                </p>
              </div>
            </li>
          </ul>
          <ng-template #noAlerts>
            <div class="no-alerts">
              <p>{{ 'NoLowStockAlerts' | translate }}</p>
            </div>
          </ng-template>
        </mat-menu>

        <!-- Existing Notification Bell -->
        <i
          class="fa fa-bell"
          aria-hidden="true"
          [matMenuTriggerFor]="menu1"
          matBadge=""
          matBadgePosition="above after"
          matBadgeColor="warn"
          matBadgeSize="small"></i>

        <mat-menu
          #menu1="matMenu"
          xPosition="before"
          yPosition="below"
          class="noti_dropBox">
          <div class="d_flx">
            <h2>{{ 'Notifications' | translate }}</h2>
            <button
              class="see_link"
              routerLink="/received_notification"
              type="button">
              {{ 'SeeAll' | translate }}
            </button>
          </div>

          <ul class="not_list" *ngIf="notifications.length > 0; else noNotifications">
            <li class="ntf-list" *ngFor="let item of notifications">
              <div class="ntf_dt">
                <h3>{{item.title}}</h3>
                <p>{{item.message}}</p>
                <p class="ntf_tym">{{getTimeAgo(item.createdAt)}}</p>
              </div>
            </li>
          </ul>
          <ng-template #noNotifications>
            <div class="no-notifications">
              <p>{{ 'NoNotifications' | translate }}</p>
            </div>
          </ng-template>
        </mat-menu>
        <!-- Language Switcher -->
        <div
          class="lang_switch"
          mat-button
          [matMenuTriggerFor]="languageMenu"
          [matTooltip]="'SelectLanguage' | translate">
          <mat-icon>language</mat-icon>
          <span class="lang_code">{{ currentLanguage | uppercase }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </div>

        <mat-menu #languageMenu="matMenu" yPosition="below" class="dropdown dropbox">
          <ul class="hd_menu">
            <li
              *ngFor="let language of languages"
              [class.active]="language.code === currentLanguage"
              (click)="changeLanguage(language.code)">
              {{ language.label }}
            </li>
          </ul>
        </mat-menu>

        <div class="drop_down" mat-button [matMenuTriggerFor]="belowMenu">
          <figure >
            <img
              [src]="
                profile && profile.image
                  ? profile.image
                  : assetsConst.profileLogo
              "
              alt="profile" />
          </figure>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </div>

        <mat-menu
          #belowMenu="matMenu"
          yPosition="below"
          class="dropdown dropbox">
          <ul class="hd_menu">
            <li routerLink="/profile/profile">
              <figure>
                <img [src]="assetsConst.userLogo" alt="profile" />
              </figure>
              {{ 'MyProfile' | translate }}
            </li>
            <li routerLink="/password/change-paswd">
              <figure>
                <img [src]="assetsConst.passwordLogo" alt="profile" />
              </figure>
              {{ 'ChangePassword' | translate }}
            </li>
            <li (click)="logout()">
              <figure>
                <img [src]="assetsConst.logoutLogo" alt="profile" />
              </figure>
              {{ 'Logout' | translate }}
            </li>
          </ul>
        </mat-menu>
      </div>
    </div>
    <router-outlet></router-outlet>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
